import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

export const FeatureArticleWrapper = styled.div`
  @media (${breakpoint.xlMin}) {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 40px;
  }
`;

export const ArticleList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 40px;

  .sections-small-card {
    &:last-child {
      display: none;
    }
  }

  @media (${breakpoint.mdMin}) {
    grid-template-columns: unset;

    .sections-small-card {
      &:last-child {
        display: flex;
      }
    }
  }

  @media (${breakpoint.xlMin}) {
    margin-top: unset;
    display: flex;
    flex-direction: column;
  }

  li.nativo-tout--term-archive-1 {
    list-style: none;
    width: 100%;

    a.ntvAdChoicesLink {
      display: none;
      position: absolute;
    }

    a.ntv-headline-anchor {
      margin: 0;
      padding: 0;
      border: 0;
      box-sizing: border-box;
      vertical-align: baseline;
    }

    @media (${breakpoint.mdMin}) {
      .ntv-tout-wrap {
      flex-direction: row;

        img {
          min-width: 164px;
          max-width: 164px; 
          max-height: 109px;
        }
      }
    }

    .nativo-tout--term-archive-1__title {
      font-size: 16px;
      line-height: 120%; 
      letter-spacing: 0.4px;
    }

  }
`;
